module.exports = __webpack_public_path__ + "static/media/OpenCV.db9690da.svg";